"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M23.019 38H20V10h10v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V8a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v7a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5h10v28h-3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h10.633zm24.649-8.99l-4.68-4.68a.986.986 0 0 0-.7-.287h-.031a1.113 1.113 0 0 0-.753.33L27.055 38.82a.81.81 0 0 0-.2.342l-2.813 8.112c-.092.306.373.691.636.691a.223.223 0 0 0 .05-.005c.224-.052 6.944-2.461 8.117-2.814a.8.8 0 0 0 .336-.2L47.624 30.5a1.116 1.116 0 0 0 .328-.717.992.992 0 0 0-.284-.773zM32.18 43.645c-1.754.527-4.5 1.748-6.02 2.2l2.189-6.022z" })
);

